import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackRatingTrendQueryVariables = Types.Exact<{
  input: Types.GuestFeedbackRatingTrendInput;
}>;


export type GuestFeedbackRatingTrendQuery = { __typename?: 'Query', GuestFeedbackRatingTrend: Array<{ __typename?: 'GuestFeedbackRatingTrendPoint', weekStart: string, avgRating: number, count: number }> };


export const GuestFeedbackRatingTrendDocument = gql`
    query GuestFeedbackRatingTrend($input: GuestFeedbackRatingTrendInput!) {
  GuestFeedbackRatingTrend(input: $input) {
    weekStart
    avgRating
    count
  }
}
    `;

/**
 * __useGuestFeedbackRatingTrendQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackRatingTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackRatingTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackRatingTrendQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestFeedbackRatingTrendQuery(baseOptions: Apollo.QueryHookOptions<GuestFeedbackRatingTrendQuery, GuestFeedbackRatingTrendQueryVariables> & ({ variables: GuestFeedbackRatingTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackRatingTrendQuery, GuestFeedbackRatingTrendQueryVariables>(GuestFeedbackRatingTrendDocument, options);
      }
export function useGuestFeedbackRatingTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackRatingTrendQuery, GuestFeedbackRatingTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackRatingTrendQuery, GuestFeedbackRatingTrendQueryVariables>(GuestFeedbackRatingTrendDocument, options);
        }
export type GuestFeedbackRatingTrendQueryHookResult = ReturnType<typeof useGuestFeedbackRatingTrendQuery>;
export type GuestFeedbackRatingTrendLazyQueryHookResult = ReturnType<typeof useGuestFeedbackRatingTrendLazyQuery>;
export type GuestFeedbackRatingTrendQueryResult = Apollo.QueryResult<GuestFeedbackRatingTrendQuery, GuestFeedbackRatingTrendQueryVariables>;